// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Redux:
import { getPageData } from 'actions/page'
import { currentPage } from 'selectors/page'

class PageHeader extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			imageLoaded: false
		}
	}

	componentWillReceiveProps( nextProps ) {
		if ( ! this.props.page || this.props.page == nextProps.page ) {
			return
		}

		const { page } = this.props

		if ( page.featured_image.url != nextProps.page.featured_image.url ) {
			this.setState({
				imageLoaded: false
			})
		}
	}

	handleImageLoaded = () => {
		this.setState({
			imageLoaded: true
		})
	}

	renderLoading() {
		return (
			<div className="page-header page-header-is-loading">
				<div className="-inner">
					<div className="-image"></div>
				</div>
			</div>
		)
	}

	renderContent() {
		const { page } = this.props
		const { imageLoaded } = this.state
		const wrapClass = imageLoaded ? '-image is-loaded' : '-image'

		if ( ! page ) {
			return (
				<div className="page-header">
					<div className="-inner">

					</div>
				</div>
			)
		}

		var image
		const featuredImage = page.featured_image
		const srcset = featuredImage.srcset ? featuredImage.srcset : undefined

		if ( page.featured_image.url ) {
			image = (
				<div className={ wrapClass }>
					<img
						className="-img -thumb"
						src={ featuredImage.thumb }
						alt={ featuredImage.alt }
					/>

					<img
						className="-img -full"
						alt={ featuredImage.alt }
						src={ featuredImage.url }
						width={ featuredImage.width }
						height={ featuredImage.height }
						srcSet={ srcset }
						sizes="100vw"
						onLoad={ this.handleImageLoaded }
					/>

					{ ( !! page.featured_image_link && page.featured_image_link.indexOf( 'http' ) > -1 ) &&
						<a href={ page.featured_image_link } target="_blank" rel="noopener"></a>
					|| ( !! page.featured_image_link ) &&
						<Link to={ page.featured_image_link }></Link>
					}
				</div>
			)
		} else {
			image = (
				<div className="-image">
					<img className="-img -full" src={ safeSiteData.site_featured_image_url } alt="" />
				</div>
			)
		}

		return (
			<div className="page-header">
				<div className="-inner">
					{ image }
				</div>
			</div>
		)
	}

	render() {
		// return (
		// 	<div>
		// 		{ this.props.page.isLoading ? this.renderLoading() : this.renderContent() }
		// 	</div>
		// )

		return (
			<div>
				{ this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: currentPage( state )
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( PageHeader )



// WEBPACK FOOTER //
// ./components/page-header/page-header.jsx